/**
 * @file The in-app path that uploads or publishes a pricebook edition: S1's
 * Pricebooks tab, the fix a check skipped for want of an edition links to.
 * Shared so the server's `fixHref` and the client's links cannot drift.
 * Consumers: `checkCatalogGrammar`, whose skipped result carries it as
 * `fixHref` while a manufacturer of the schedule has no published edition
 * (with that manufacturer's entity record id as `&manufacturer=` when it is
 * one), `checkAllowedValues`, and the client's `ScheduleNoticeAlert` and
 * `ScheduleWaitingOnCell`.
 */
export const PRICEBOOK_UPLOAD_HREF = '/intake?tab=pricebooks';
